import React from "react";
import PropTypes from "prop-types";

const Button = ({ buttonText, onClick, isDisabled }) => {
  return (
    <div className="hrd-button-row">
      <button
        type="button"
        className="hrd-next-button"
        onClick={onClick}
        disabled={isDisabled}
      >
        {buttonText}
      </button>
    </div>
  );
};

Button.propTypes = {
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

Button.defaultProps = {
  isDisabled: false,
};

export default Button;